<template>
	<vue-date-picker ref="container" v-model="date" v-bind="$attrs" :format="format" :range="range" @change="onSelection">
		<template v-slot:input="slotProps">
			<masked-input type="text" :mask="inputMask" v-model="inputVal" :guide="true" v-bind="slotProps.props" v-on="slotProps.events" @input="onInputChange"></masked-input>
		</template>
	</vue-date-picker>
</template>

<script>

import moment from 'moment';
import VueDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { isValid, isBefore } from 'date-fns';
import _ from 'underscore';

const RANGE_SEPARATOR = ' - ';

function formattedDate(value) {
	if (moment.isMoment(value)) {
		value = value.toDate();
	}

	if (value instanceof Date) {
		return value.toLocaleDateString('en-US', {
			month: '2-digit', day: '2-digit', year: 'numeric',
		});
	}

	return value;
}

function getInputVal(value) {
	if (Array.isArray(value)) {
		return `${formattedDate(value[ 0 ])}${RANGE_SEPARATOR}${formattedDate(value[ 1 ])}`;
	}

	return formattedDate(value);
}

function parse(value, isRange) {
	if (typeof value === 'string') {
		if (!isRange) {
			return new Date(date);
		}

		value = value.split(RANGE_SEPARATOR);
	}

	if (Array.isArray(value)) {
		return value.map(date => new Date(date));
	}

	return value;
}

export default {

	props: ['value', 'name', 'range', 'placeholder'],

	data() {
		return {
			date: this.value,
			inputVal: getInputVal(this.value),
		};
	},

	watch: {
		date: function(newValue) {
			if (newValue !== this.value) {
				this.$emit('input', newValue);
			}
			const newInputVal = getInputVal(newValue);
			if (newInputVal !== this.inputVal) {
				this.inputVal = newInputVal;
			}
		},
		value: function(newValue) {
			if (!_.isEqual(newValue, this.date)) {
				this.date = newValue;
			}
		},
	},

	computed: {

		format() {
			return 'MM/DD/YYYY';
		},

		isRange() {
			return (!!this.range);
		},

		inputMask() {
			const d = /\d/;
			let dateMask = [d, d, '/', d, d, '/', d, d, d, d];
			if (this.isRange) {
				return [
					...dateMask,
					...RANGE_SEPARATOR.split(''),
					...dateMask,
				];
			}

			return dateMask;
		},

	},

	methods: {
		onSelection() {
			if (this.isValid(this.date)) {
				this.inputVal = getInputVal(this.date);
			} else {
				this.inputVal = null;
			}
		},

		onInputChange() {
			const date = parse(this.inputVal, this.isRange);
			const isValid = this.isValid(date);
			if (isValid) {
				this.date = date;
			}

			this.setValid(isValid);
		},

		isValid(input) {
			if (!input) return false;

			if (Array.isArray(input) || !(input instanceof Date || this.isRange)) {
				return this.isRangeValid(input);
			} else {
				return isValid(input);
			}
		},

		isRangeValid(input) {
			let dates = typeof input === 'string' ? input.split(RANGE_SEPARATOR) : input;

			if (dates.length !== 2) return false;

			if (!isValid(dates[ 0 ]) || !isValid(dates[ 1 ])) return false;

			return isBefore(dates[ 0 ], dates[ 1 ]);
		},

		setValid(isValid) {
			const inputContainer = this.$refs.container.$el.closest('.input-container');
			if (!inputContainer) {
				return;
			}

			inputContainer.classList[isValid ? 'remove' : 'add']('bad-input-notice');
		},
	},

	components: {
		VueDatePicker,
	},
};

</script>
